import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { Why } from "@/components/Why";
import { CTASection } from "@/components/CTASection";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function AboutPage() {
  usePageMeta({
    title: "About | BrandZenith",
    description:
      "BrandZenith is an AI-powered brand growth studio — strategy, creativity and technology under one roof. Not another agency: a growth partner built for what's next.",
    path: "/about",
  });

  return (
    <>
      <Navbar />
      <main>
        <PageHeader
          overline="About BrandZenith"
          title="Built for"
          accent="what's next."
          copy="BrandZenith is an AI-powered brand growth studio — strategy, creativity and technology under one roof."
        />
        <section data-testid="about-manifesto" className="relative py-20 lg:py-28">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20">
            <Reveal>
              <h2 className="font-display text-3xl sm:text-5xl font-extrabold uppercase tracking-tight leading-[1.05]">
                Not another agency. <span className="text-gradient-purple">A growth partner.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="space-y-6 text-base sm:text-lg text-[#A6A6B0] leading-relaxed">
                <p>
                  BrandZenith exists for one reason: to give ambitious brands the strategy,
                  creativity and intelligent systems they need to move — faster than the market,
                  sharper than the noise.
                </p>
                <p>
                  We are AI-first by design. Not to replace the human craft, but to amplify it —
                  so every idea travels further, every campaign ships faster, and every brand we
                  touch is built for what's next.
                </p>
              </div>
            </Reveal>
          </div>
        </section>
        <Why />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}
